import React, {useEffect, useState} from 'react'
import {Button, Col, Container, Modal, Row} from "react-bootstrap";
import {isValid} from "../../scripts/myga-session";

const EndRecordingModal = props => {
  let propShow = isValid(props.show) ? props.show : false
  let [show, setShow] = useState(propShow)

  useEffect(() => {
    setShow(propShow)
  }, [propShow])

  return (
    <Modal
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      show={show}
      onHide={props.onHide}
    >

      <Modal.Header closeButton>
        <Modal.Title>End Test Recording</Modal.Title>
      </Modal.Header>

      <Modal.Body>
          <Container className={'download-modal-form-container col-12 col-lg-7'}>
            <Row>
              <Col>
                <div>Are you sure you want to end this test recording?</div>
              </Col>
            </Row>
          </Container>
      </Modal.Body>

      <Modal.Footer style={{justifyContent: 'space-between', flexWrap: 'nowrap'}}>
        <Button id={'test_end_no'} variant="secondary" onClick={props.onHide}>
          No
        </Button>
        <Button id={'test_end_ok'} variant="primary" onClick={props.handleYes}>
          Yes
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default EndRecordingModal